module.exports = __webpack_public_path__ + "static/media/sdg-bg.e09417cc.png";